const getFeaturedPromoCode = (locale) => {
  const customer = process.env.NEXT_PUBLIC_CUSTOMER;

  if (customer === "lgd") {
    return null;
  }

  switch (locale) {
    default:
      return "CLOSY10";
  }
};

export default getFeaturedPromoCode;
